import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography } from '@biome-design-system/ui/Typography';
import { Link } from '@biome-design-system/ui/Link';
import { Breadcrumbs } from '@biome-design-system/ui/Breadcrumbs';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { PMCConfig } from '@kyruus/types';
import { Log, SearchQuery } from 'Src/types';
import { getProviderDisplayName } from 'Src/provider/utils';
import {
  getBackToSearchLinkDestination,
  getNewSearchLinkDestination
} from './lib/utils';
import { messages } from './lib/messages';

interface BaseSearchBreadcrumbsProps {
  config: PMCConfig;
  currentQuery?: SearchQuery;
  log: Log;
  provider: string;
}
type SearchBreadcrumbsProps = BaseSearchBreadcrumbsProps &
  WrappedComponentProps;

export const SearchBreadcrumbs = injectIntl(
  ({ config, currentQuery, intl, log, provider }: SearchBreadcrumbsProps) => {
    const providerName = getProviderDisplayName(provider);
    const isFromExternalPage = currentQuery?.from === undefined;
    const linkDestination = isFromExternalPage
      ? getNewSearchLinkDestination({ config, currentQuery })
      : getBackToSearchLinkDestination({ currentQuery });

    const handleClick = () => {
      if (log) {
        log(`user_action.provider_detail.search_breadcrumb`);
      }
    };

    return (
      <Breadcrumbs>
        <Link
          to={linkDestination}
          onClick={handleClick}
          component={RouterLink}
          id="profile-search-breadcrumb"
        >
          {intl.formatMessage(messages.searchBreadcrumbLink)}
        </Link>
        <Typography aria-current="page">{providerName}</Typography>
      </Breadcrumbs>
    );
  }
);
